import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { cloneDeep, sortBy } from 'lodash';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function ClonePlugCustomTemplateRuleModal(props) {
  const {
    show,
    onHide,
    showToast,
    isSaving,
    setIsSaving,
    rules,
    setTemplates,
    setActiveRuleId,
    activeTemplateId,
    organizationId,
  } = props;

  const [templateRuleName, setTemplateName] = useState('');
  const [cloneRuleId, setCloneRuleId] = useState('')

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (templateRuleName && cloneRuleId) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [templateRuleName, cloneRuleId]);

  const cloneTemplateRule = (e) => {
    e.preventDefault();
    setIsSaving(true);
    ApiServiceServerless.post(
      `/custom_templates/rule/clone/${cloneRuleId}`,
      {
        name: templateRuleName,
        custom_template_id: activeTemplateId,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setTemplates((prev) =>
          prev.map((template) => {
            if (template.id !== activeTemplateId) return template;
            let new_template = cloneDeep(template);
            new_template.rules = [...new_template.rules, res.data];
            return new_template;
          })
        );
        setActiveRuleId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsSaving(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setTemplateName('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Clone Template Rule</Modal.Header>
      <Form onSubmit={cloneTemplateRule}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Rule Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Rule To Clone
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>

            <Form.Control
              as='select'
              required
              onChange={(e) => {
                setCloneRuleId(parseInt(e.target.value));
              }}
            >
              <option key={'opt-null'} value={''} hidden>
                -
              </option>
              {rules.length === 0 && (
                <option key={'null-null'} value={''} disabled>
                  No existing rules
                </option>
              )}
              {sortBy(rules, ['name']).map((rule) => (
                <option key={'opt-' + rule.id} value={rule.id}>
                  {rule.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isSaving}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
